<template>
  <div>
    <v-card>
      <v-card-title>
        <span v-if="showTitle"></span>
        <div class="flex-grow-1"></div>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          @keyup="searchChange"
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-container v-if="showDense">
          <v-row>
            <v-col>
              <v-checkbox label="Dense" v-model="dense"></v-checkbox>
            </v-col>
          </v-row>
        </v-container>

        <v-data-table
          :items="filteredItems"
          :headers="headers"
          :loading="loading"
          :footer-props="footerProps"
          :dense="dense"
          item-key="code"
          :show-select="showSelect"
          text="Loading... Please wait"
          v-model="selected"
        >
          <template v-slot:header.data-table-select>
            <v-checkbox @change="toggleAll" color="default" v-model="selectAll" value />
            <!-- <v-checkbox
              @change="toggleAll"
              color="default"
              :indeterminate="props.indeterminate"
              value
              v-else
            />-->
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
const API_ENDPOINT = "/api/other";
// import EventBus from "../../../../../events/eventBus";
export default {
  props: {
    showTitle: {
      default: true,
      type: Boolean
    },
    showDense: {
      default: true,
      type: Boolean
    },
    byUser: {
      default: false,
      type: Boolean
    },
    headers: {
      default: () => [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "action"
        },
        {
          text: "Code",
          align: "left",
          //sortable: false,
          value: "code"
        },
        {
          text: "Description",
          align: "left",
          //sortable: false,
          value: "description"
        }
      ],
      type: Array
    },
    showSelect: {
      default: false,
      type: Boolean
    },
    value: {
      default: () => [],
      type: Array
    }
  },
  data: () => ({
    items: [],
    search: "",
    footerProps: {
      rowsPerPageItems: [10, 25, 50, 100]
    },
    loading: false,
    dense: false,
    selected: [],
    selectAll: false
  }),
  computed: {
    filteredItems() {
      return this.filterItems(this.items, this.search);
    }
  },
  methods: {
    toggleAll() {
      if (this.selectAll) {
        if (this.search !== "") {
          this.selected = this.filteredItems;
        } else {
          this.selected = this.items.slice();
        }
      } else {
        if (this.selected.length) {
          this.selected = [];
        } else {
          if (this.search !== "") {
            this.selected = this.filteredItems;
            this.selectAll = true;
          } else {
            this.selected = this.items.slice();
          }
        }
      }
    },
    getAll() {
      const apiURL = `${API_ENDPOINT}${this.byUser ? "/user" : "/cdistrict"}`;
      this.$axios
        .get(apiURL)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    selectedChanged(val) {
      //   EventBus.$emit("SELECTED_BRANCH", Object.assign([], val));

      var items = val.map(function(item) {
        return item.code;
      });
      this.$emit("input", Object.assign([], items));
    },
    filterItems(items, query) {
      var filtered = items.filter(item => {
        let code = item.code.toString().includes(query.toLowerCase());
        let desc = item.description.toLowerCase().includes(query.toLowerCase());

        return code || desc;
      });
      return filtered;
    },
    searchChange(e) {
      if (e.target.value === "") {
        this.selectAll = false;
        if (this.selected.length === this.items.length) this.selectAll = true;
        else this.selectAll = false;
      }
    }
  },
  created() {
    this.getAll();
  },
  mounted() {
    // this.getAll();
    // EventBus.$on("TOGGLE_SELECTED_BRANCH", payload => {
    //   this.selected = payload;
    // });
  },
  watch: {
    selected(val) {
      this.selectedChanged(val);
      if (this.search !== "") {
        if (val.length !== this.filteredItems.length) this.selectAll = false;
        else this.selectAll = true;
      } else {
        if (val.length !== this.items.length) this.selectAll = false;
        else this.selectAll = true;
      }
    },
    search(val) {
      this.filterItems(this.items, val);
    }
  }
};
</script>